import { LocationNumbersService } from '../../../services'

const resubmitTollFreeVerification = async function (
  { commit, state, getters },
  config
) {
  const { companyId, locationId, tollfreePhoneNumberSid, tollfreeVerificationSid, payload } = config

  try {
    const {data} = await LocationNumbersService.reSubmitTollFreeVerificationRequest(
      companyId,
      locationId,
      tollfreeVerificationSid,
      payload
    ) as any

    const requestData = data?.tollFreeRequest

    requestData.status = "IN_REVIEW"

    commit('setTollFreeDataAt', {
      sid: tollfreePhoneNumberSid ?? requestData?.tollfreePhoneNumberSid ?? requestData?.tollfree_phone_number_sid,
      tollFreeRequest: requestData,
    })

    commit(
      'setPhoneNumbers',
      getters.getCorrectedPhoneNumbers(state.phoneNumbers)
      )

    return Promise.resolve(requestData)
  } catch (error) {
    commit('setTollFreeDataAt', {
      sid: tollfreePhoneNumberSid,
      tollFreeRequest: null,
    })
    return Promise.reject(error)
  }
}

export default resubmitTollFreeVerification
